import $ from 'jquery';
import './lib/polyfills';
// Swiper Carousel
import Swiper from 'swiper';

// Select2 Plugin
import 'select2/dist/js/select2.full'; // we want the full version
import 'select2/dist/css/select2.css';

// Our site styles
import '../scss/site.scss';

// Foundation
import whatInput from 'what-input';
import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
// see https://github.com/zurb/foundation-zurb-template
import './lib/foundation-explicit-pieces';
import './lib/service-worker-register';

// Navigation
import './navigation';

// Carousel
import initializeCarousels from './carousel';

// Chat
// import './chat';
import './forms';

// On Scroll Animation
// see https://github.com/michalsnik/aos
import AOS from 'aos';
import 'aos/dist/aos.css';

const Site = {
  initializeFoundation: function() {
    $(document).foundation();
    initializeCarousels();
    AOS.init();
  }
};

export { Site };
